/**
 * Gets quest by its id
 * @param {Array[Object]} quests - set of quests where search will be processed
 * @param {Number} questId - id of the quest to find
 * @returns {Object|Undefined}
 */
export function findQuest(quests, questId) {
  return (quests || []).find((quest) => quest.id === questId);
}

/**
 * Copies selected by `questId` quest
 * @param {Object} state - Redux state of the `quests` store, containing `quests` array
 * @param {Number} id - id of the targeted quest
 * @returns {Object|null} - quest copy
 */
export function copyQuest(state, id) {
  const filtered = (state.quests || []).filter((quest) => quest.id === id);
  if (!filtered || !filtered.length) return null;
  return { ...filtered[0] };
}

/**
 * Finds event in `quests[].events[]` store
 * @param {Array[Object]} events - where to find event
 * @param {String} id - id of the event
 * @param {Boolean} indexRequired - if position in array should be returned
 * @returns {Object|Number|null}
 */
export function findEvent(events, id, indexRequired) {
  if (!events) return indexRequired ? -1 : null;
  if (indexRequired) {
    return events.findIndex((event) => event.id === id);
  }

  return events.find((event) => event.id === id) || null;
}

/**
 * Replaces quest in state.quests array with updated quest
 * @param {Object} state - Redux state of quests
 * @param {Object} quest - Updated quest object
 * @returns {Object} - New state
 */
export function stateWithNextQuest(state, quest) {
  const questId = quest.id;
  return {
    ...state,
    quests: (state.quests || []).map((q) => (q.id === questId ? quest : q)),
  };
}

/**
 * Updates quest lastModifiedText timestamp and marks copies unsynchronized
 * @param {Object} quest - Quest copy being modified
 * @returns {Object}
 */
export function touchQuestModified(quest) {
  if (!quest) return quest;
  /* eslint-disable no-param-reassign */
  quest.lastModifiedText = new Date().toISOString();
  quest.copies = (quest.copies || []).map((copy) => ({
    ...copy,
    synchronized: false,
  }));
  /* eslint-enable no-param-reassign */
  return quest;
}
